// extracted by mini-css-extract-plugin
module.exports = {"six-story-4s":"styles-m__six-story-4s__3WXCO","title":"styles-m__title__2wTyv","story-card":"styles-m__story-card__1-wUY","story-container":"styles-m__story-container__lya_R"};